export default {
    login: {
        title: '欢迎登录',
        mobile: '请输入手机号',
        password: '请输入密码',
        confirmPwd: '请输入确认密码',
        verificationCode: '请输入验证码',
        loginIn: '登 录',
        register: '注 册',
        reset: '重置密码',
        resetPwd: '重置密码',
        newPwd: '请输入新密码'
    },
    Notification: {
        suc_title: '成功',
        suc_login_msg: '成功登录',
        suc_send_msg: '成功发送',
        codeAgain: '重新获取验证码',
        suc_submit: '成功提交',
        login_tip: '请先登录',
        tip: '提示',
        sure: '确定',
        next: '下一步',
        requiredFields: '请完善必填项',
        nodata: '暂无数据',
        read: '已读',
        unread: '未读',
        cancel: '取消',
        print: '打印',
        submit_tip: '确认提交后不可再修改, 是否继续',
        suc_confirm_msg: '成功确认',
        profile_photo: '头像',
        no: '第',
        filemessage: '个上传文件',
        min_file: '最小上传数为',
        errorTouGao: '投稿已结束'
    },
    tougao: {
        submit: '提交',
        correct_mobile: '请输入正确的手机号',
        correct_email: '请输入正确的邮箱',
        corrent_card: '请输入正确的证件号',
        basic_info: '基本信息',
        zuopin_info: '作品信息',
        cancel: '取消',
        sure: '确定',
        receipt: '投稿回执'
    },
    my: {
        name: '名称',
        category: '类别',
        ticket: '流水号',
        status: '状态',
        operate: '操作',
        edit: '修改',
        sure: '确认',
        view: '查看',
        confirm: '提交',
        receipt: '回执',
        logout: '退 出'
    }
}
